module.exports = __webpack_public_path__ + "static/img/menu.08e7a836.png";